<template>
    <div :style="{'height' : domHeight +'px' }">
        <div name="org_tree" class="org-tree-layout">
            <swb-popover-org-tree :showRealCom="true" :onlyShowRealCom="true" :prftFlag="false" :selectRealComId="selectRealComId" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <swb-contract-search name="contract_search" :queryRef="queryRef" :contractType="contractType" :isFstParty="true" :tag="fstPartyFlag" @notity-syncRefresh="searchSyncRefresh" ref="swb_contract_search"></swb-contract-search>
        <div name="tabs" class="tab-container small base">
            <div class="tabs-nav">
                <ul class="head">
                    <li class="head-item" v-for="(text, value) in contractStateList" :class="{'current': value == checkStateValue}" @click="changeStatue(value)">
                        <span>{{ text }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div name="btns" class="simple-row">
            <div class="left">
                <button v-if="checkActionPerm('add')" @click="goRegisterContract();" class='swb-btn swb-btn-small'>
                    <!--<i class='icon iconfont icon-jiahao mr5'></i>--><span>新增合同</span>
                </button>
                <span><el-checkbox class="ml15" v-model="relevanceCallBid" @change="changeCheckBox">关联招投标</el-checkbox></span>
                <span><el-checkbox class="ml15" v-model="relevanceReply" @change="changeCheckBox">关联询价单</el-checkbox></span>
                <span><el-checkbox class="ml15" v-model="userCreate" @change="changeCheckBox">自己创建</el-checkbox></span>
            </div>
            <div class="right" v-if="contractType == goodsPurch.value">
                <a class="swb-btn swb-btn-small swb-btn-primary" @click="generalImport">合同导入</a>
            </div>
        </div>

        <swb-result-table name="result_table" ref="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {DomSizeWatcher, MsgBox, Routes, Vue} from '../../app.vues'
    import appConf from '../../app.conf';

    import {getDefaultPageSizes} from '../../../src/app.conf'
    import {openContractFormatExplDlg, openContractImpCheckDlg, openContractLogListDlg, openContractModifyDlg, openContractPhasedPaySettingModifyDlg, openContractServcPurchModifyDlg} from './dialog'
    import {showComActionPostSelectDlg, showMsgDlg} from '../merchant/showSelectDlg';
    import {checkUserActionPerm} from '../index'
    import {fileUploadGroupShowDlg} from '../comn/dialog'
    import {showPayVoucherListForSelectDlg} from '../payment/ActRecDlg'
    import {voucherType} from '../../../resc/app/js/voucherType';
    import {getMerchantBizParam, getRealCtrlParam} from '../asset/assetMain'
    import {showRouteLayer} from '../ctrl/RouteLayer'

    import retailerApi from '../../api/retailer'
    import userApi from '../../api/user'
    import contractApi from '../../api/contract'
    import merchtQualiApi from '../../api/merchtQuali'
    import merchtComnApi from '../../api/merchtComn'
    import devcReqrApi from '../../api/devcReqr'

    import SwbContractSearch from './ContractSearch';
    // 商品下订单
    import SwbSaveGoodsOrder from '../order/SaveGoodsOrder';
    // 服务下订单
    import SwbServcOrderCreate from '../servcOrder/ServcOrderCreate';
    //
    import SwbCheckContract from './CheckContract';
    //
    import SwbShowSourceTrace from './ShowSourceTrace';
    //
    import SwbContractAppliedShopList from './ContractAppliedShopList'
    import SwbGoodsPurchContractList from './GoodsPurchContractList';
    import SwbServcPurchContractList from './ServcPurchContractList';
    import SwbIntegPurchContractList from './IntegPurchContractList';
    import SwbContractServcOrderList from '../servcOrder/ContractServcOrderList';
    import SwbContractGoodsOrderList from '../order/ContractGoodsOrderList';
    import SwbDealInqryVoucherList from '../InqryVoucher/DealInqryVoucherList';
    import SwbPriceInpryList from '../priceInpry/PriceInpryList';
    import SwbCallBidDocList from '../callbid/CallBidDocList';
    import SwbPurchReceiptList from '../receipt/PurchReceiptList';
    import SwbPopoverOrgTree from '../orgStruct/PopoverOrgTree';
    import SwbRegisterGoodsPurchContract from './RegisterGoodsPurchContract';
    import SwbRegisterServcPurchContract from './RegisterServcPurchContract';
    import SwbRegisterIntegPurchContract from './RegisterIntegPurchContract';
    import receiptApi from "../../api/receipt";

    Vue.regist(SwbContractSearch);

    Routes.add(SwbSaveGoodsOrder);

    Routes.add(SwbServcOrderCreate);

    Vue.regist(SwbCheckContract);

    Vue.regist(SwbShowSourceTrace);

    Vue.regist(SwbContractAppliedShopList);

    Routes.add(SwbGoodsPurchContractList);

    Routes.add(SwbServcPurchContractList);

    Routes.add(SwbIntegPurchContractList);

    Routes.add(SwbContractServcOrderList);

    Routes.add(SwbContractGoodsOrderList);

    Routes.add(SwbDealInqryVoucherList);

    Routes.add(SwbPriceInpryList);

    Routes.add(SwbCallBidDocList);

    Routes.add(SwbPurchReceiptList);

    Vue.regist(SwbPopoverOrgTree);
    Vue.regist(SwbRegisterGoodsPurchContract);
    Vue.regist(SwbRegisterServcPurchContract);
    Vue.regist(SwbRegisterIntegPurchContract);

    export default {
        name: 'swb-comn-contract-list',
        desc: '合同列表',
        props: ['domHeight', 'contractType', 'merchant', 'path', 'thisPath', 'stateValue', 'sndPartyId', "currentRealComId"],
        data: function () {
            return {
                queryRef: "query_sort_area",
                confKey: "swb-comn-contract-list",
                tableHeight: 400,
                queryOnLoad: true,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                contractList: [],
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                fstPartyHtBh: null,
                sndPartyName: null,
                selectTab: true,
                title: null,
                dateStart: null,
                dateEnd: null,
                contractStateList: [],
                checkStateValue: 0,
                no: null,
                fstPartyFlag: null,

                goodsPurch: {},
                servcPurch: {},
                integPurch: {},

                userInfo: {
                    scopeEntity: {}
                },
                relevanceCallBid: false,
                relevanceReply: false,
                userCreate: false,
                callBidDocSource: {},
                priceInqrySource: {},
                estmtAmountBefore: null,
                estmtAmountAfter: null,
                retailerStaffList: [],
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                taxPayTypeMap: getEnumMap("taxPayType", "value2text"),
                contractKindMap: getEnumMap("contractKind", "value2text"),
                selectRealComId: null,
                showAssetInfo: false,
                modification: false,
                exportParams: {},
                phasedPaymentAllowed: true
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            let routeQuery = this.$getRouteQuery();
            let no = routeQuery.no || null;
            this.title = routeQuery.title || null;
            if (!Utils.isNoB(no)) {
                this.no = no;
                this.queryModel.filterItems.no = no;
            }
            if (!Utils.isNoB(this.stateValue)) {
                this.checkStateValue = this.stateValue;
            }
            let self = this;
            getMerchantBizParam("display.asset.related.info.in.trading", function (result) {
                self.showAssetInfo = Utils.isTrue(result);
            });
            // 合同是否允许修订
            getMerchantBizParam("contract.modification.is.allowed", function (result) {
                self.modification = Utils.isTrue(result);
            });
            getRealCtrlParam('contract.settle.phased.payment.allowed', function (result) {
                self.phasedPaymentAllowed = Utils.isTrue(result);
            });
            this.getContractState();
            this.getStaffByComId();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="org_tree"], [name="contract_search"], [name="tabs"], [name="btns"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs[self.queryRef];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'no': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if (!Utils.isNoB(row.no)) {
                            if (self.checkActionPerm('view')) {
                                domHtml = domHtml + '<a class="font-blue" href="#">' + row.no + '</a>';
                            } else {
                                domHtml = domHtml + '<span>' + row.no + '</span>';
                            }
                            if (row.offline) {
                                domHtml = domHtml + '<i class="swb-icon under-line"></i>';
                            }
                            if (row.proxied) {
                                domHtml = domHtml + '<div class="table-tips"></div>';
                            }
                        }
                        return domHtml;
                    },
                    'kindIdText': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.kindId != null) {
                            return '<span>' + self.contractKindMap[row.kindId] + '</span>';
                        }
                    },
                    'fstTaxPayTypeText': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.fstTaxPayType != null) {
                            return '<span>' + self.taxPayTypeMap[row.fstTaxPayType] + '</span>';
                        }
                    },
                    'sndTaxPayTypeText': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.fstTaxPayType != null) {
                            return '<span>' + self.taxPayTypeMap[row.sndTaxPayType] + '</span>';
                        }
                    },
                    'estmtAmount': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.kindId == 0) {
                            let domHtml = '';
                            if (self.checkActionPerm('view_total_price')) {
                                if (row.estmtAmount != null) {
                                    domHtml = domHtml + '<span>' + ((row.estmtAmount).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') + '元</span>';
                                } else {
                                    domHtml = domHtml + '<span>0.00元</span>';
                                }
                            } else {
                                domHtml = domHtml + '<span>没有权限</span>';
                            }
                            return domHtml;
                        }
                    },
                    'state': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if (row.fstPartyConfirmed == false && !row.confirmed && !row.closed) {
                            domHtml = domHtml + '<el-tag type="danger" style="background-color: transparent; border: none" close-transition>';
                            if (row.fstPartyApplyState == 0 && row.sndPartyAuditState == 0) {
                                domHtml = domHtml + '<span>未申请(' + self.merchant + '未确认)</span>';
                            } else if (row.fstPartyApplyState == 0 && row.sndPartyAuditState == 1) {
                                domHtml = domHtml + '<span>未申请(' + self.merchant + '已确认)</span>';
                            } else if (row.fstPartyApplyState == 1 && row.sndPartyAuditState == 0) {
                                domHtml = domHtml + '<span>待审核(' + self.merchant + '未确认)</span>';
                            } else if (row.fstPartyApplyState == 1 && row.sndPartyAuditState == 1) {
                                domHtml = domHtml + '<span>待审核(' + self.merchant + '已确认)</span>';
                            } else if (row.fstPartyApplyState != 1 && row.fstPartyAuditState == -1 && row.sndPartyAuditState == 0) {
                                domHtml = domHtml + '<span>审核拒绝(' + self.merchant + '未确认)</span>';
                            } else if (row.fstPartyApplyState != 1 && row.fstPartyAuditState == -1 && row.sndPartyAuditState == 1) {
                                domHtml = domHtml + '<span>审核拒绝(' + self.merchant + '已确认)</span>';
                            }
                            domHtml = domHtml + '</el-tag>';
                        } else if (row.fstPartyConfirmed == true && !row.confirmed && !row.closed) {
                            domHtml = domHtml + '<el-tag type="success" style="background-color: transparent; border: none" close-transition>已确认';
                            if (row.sndPartyConfirmed == false) {
                                domHtml = domHtml + '<span>(' + self.merchant + '未确认)</span>';
                            }
                            domHtml = domHtml + '</el-tag>';
                        } else if (row.confirmed && row.curValid && !row.fullfilled && !row.closed && row.lockMode != 1 && !row.terminated) {
                            domHtml = domHtml + '<el-tag type="success" style="background-color: transparent; border: none" close-transition>';
                            if (row.lockMode == -1) {
                                domHtml = domHtml + '<span>履约中<span class="ml5 font-red">(已变更)</span></span>';
                            } else if (row.lockMode == 0) {
                                domHtml = domHtml + '<span>履约中</span>';
                            }
                            domHtml = domHtml + '</el-tag>';
                        }
                        if (row.terminated && !row.closed) {
                            domHtml = domHtml + '<el-tag type="danger" style="background-color: transparent; border: none" close-transition><span>异常终止</span></el-tag>';
                        }
                        if (row.fullfilled && row.curValid && !row.checked && row.lockMode != 1 && !row.closed) {
                            domHtml = domHtml + '<el-tag type="success" style="background-color: transparent; border: none" close-transition><span>验收中</span></el-tag>';
                        }
                        if (row.checked && row.curValid && !row.closed) {
                            domHtml = domHtml + '<el-tag type="success" style="background-color: transparent; border: none" close-transition><span>已验收</span></el-tag>';
                        }
                        if (row.closed) {
                            domHtml = domHtml + '<el-tag type="danger" style="background-color: transparent; border: none" close-transition><span>已关闭</span></el-tag>';
                        }
                        if (!row.closed && row.lockMode == 1) {
                            domHtml = domHtml + '<el-tag type="danger" style="background-color: transparent; border: none" close-transition><span>已锁定</span></el-tag>';
                        }
                        return domHtml;
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let actionList = [];
                        if (self.checkActionPerm('modify') && row.fstPartyConfirmed == false && row.fstPartyApplyState != 1 && row.fstPartyId == self.userInfo.scopeEntity.id) {
                            actionList.push({
                                name: 'modify',
                                text: '编辑'
                            })
                        }
                        // if (self.checkActionPerm('pre_pay') && !row.offline && row.confirmed && row.curValid && !row.fullfilled && !row.closed && !row.terminated) {
                        //     actionList.push({
                        //         name: 'pre_pay',
                        //         text: '预付'
                        //     })
                        // }
                        if (self.checkActionPerm('apply') && row.fstPartyApplyState != 1 && row.curValid == false && row.fstPartyConfirmed == false && row.fstPartyId == self.userInfo.scopeEntity.id) {
                            actionList.push({
                                name: 'apply',
                                text: '申请审核'
                            })
                        }
                        if (self.checkActionPerm('audit') && row.fstPartyApplyState == 1 && row.fstPartyAuditState != 1 && row.fstPartyAuditorPostId == self.userInfo.scopeEntity.postId && !row.closed && row.fstPartyId == self.userInfo.scopeEntity.id) {
                            actionList.push({
                                name: 'audit',
                                text: '审核确认'
                            })
                        }
                        if (self.checkActionPerm('invalidate') && !row.confirmed && !row.closed && row.fstPartyConfirmed == false && row.fstPartyId == self.userInfo.scopeEntity.id) {
                            actionList.push({
                                name: 'invalidate',
                                text: '作废'
                            })
                        }
                        if (self.checkActionPerm('change') && row.confirmed && row.curValid && !row.checked && row.lockMode == 0 && !row.offline && !row.terminated && row.fstPartyId == self.userInfo.scopeEntity.id) {
                            actionList.push({
                                name: 'change',
                                text: '变更'
                            })
                        }
                        if (self.checkActionPerm('phase_change') && self.phasedPaymentAllowed && self.contractType == self.goodsPurch.value && row.confirmed && row.curValid && !row.fullfilled && !row.closed && !row.checked && row.lockMode == 0 && !row.terminated && row.fstPartyId == self.userInfo.scopeEntity.id) {
                            actionList.push({
                                name: 'phase_change',
                                text: '付款阶段变更'
                            })
                        }
                        // 商品采购合同/服务合同，当业务参数开启的时候才可修订，而且必须是履约中未变更的合同 row.confirmed && row.curValid && !row.fullfilled && !row.closed && row.lockMode != 1 && !row.terminated
                        if (self.checkActionPerm('modification') && (self.contractType == self.goodsPurch.value || self.contractType == self.servcPurch.value) && self.modification && row.confirmed && row.curValid && !row.fullfilled && !row.closed && !row.checked && row.lockMode == 0 && !row.terminated && row.fstPartyId == self.userInfo.scopeEntity.id) {
                            actionList.push({
                                name: 'modification',
                                text: '修订'
                            })
                        }
                        if (self.checkActionPerm('order_goods') && self.contractType != self.servcPurch.value && row.confirmed && row.curValid && !row.fullfilled && !row.checked && row.lockMode == 0 && !row.offline && !row.terminated) {
                            actionList.push({
                                name: 'order_goods',
                                text: '订商品'
                            })
                        }
                        if (self.checkActionPerm('order_servc') && self.contractType != self.goodsPurch.value && row.confirmed && row.curValid && !row.fullfilled && !row.checked && row.lockMode == 0 && !row.offline && !row.terminated) {
                            actionList.push({
                                name: 'order_servc',
                                text: '订服务'
                            })
                        }
                        if (self.checkActionPerm('view_goods_order') && self.contractType != self.servcPurch.value && (row.curValid == true || row.closed) && !row.offline && !row.terminated) {
                            actionList.push({
                                name: 'view_goods_order',
                                text: '查看商品订单'
                            })
                        }
                        if (self.checkActionPerm('view_servc_order') && self.contractType != self.goodsPurch.value && (row.curValid == true || row.closed) && !row.offline && !row.terminated) {
                            actionList.push({
                                name: 'view_servc_order',
                                text: '查看服务订单'
                            })
                        }
                        if (self.checkActionPerm('check') && row.curValid == true && row.fullfilled && !row.checked && row.checkApplyState != 1 && row.fstPartyId == self.userInfo.scopeEntity.id) {
                            actionList.push({
                                name: 'check',
                                text: '验收'
                            })
                        }
                        if (self.checkActionPerm('check_fulfill') && row.curValid == true && !row.fullfilled && !row.checked && row.fulfillApplyState == 1 && row.fulfillAuditState != 1 && row.fstPartyId == self.userInfo.scopeEntity.id) {
                            actionList.push({
                                name: 'check_fulfill',
                                text: '履约审核'
                            })
                        }
                        if (self.checkActionPerm('keep_fulfilled') && row.curValid == true && row.fullfilled && !row.checked && row.checkApplyState != 1 && row.fstPartyId == self.userInfo.scopeEntity.id) {
                            actionList.push({
                                name: 'keep_fulfilled',
                                text: '继续履约'
                            })
                        }
                        if (self.checkActionPerm('check_audit') && row.curValid == true && row.fullfilled && !row.checked && row.checkApplyState == 1 && row.checkAuditState != 1 && row.fstPartyId == self.userInfo.scopeEntity.id) {
                            actionList.push({
                                name: 'check_audit',
                                text: '验收审核'
                            })
                        }
                        if (self.checkActionPerm('search_tag')) {
                            actionList.push({
                                name: 'search_tag',
                                text: '搜索标签'
                            })
                        }
                        if (self.checkActionPerm('set_tag')) {
                            actionList.push({
                                name: 'set_tag',
                                text: '设置标签'
                            })
                        }
                        if (self.checkActionPerm('add_biz_rel') && row.fstPartyId == self.userInfo.scopeEntity.id) {
                            actionList.push({
                                name: 'add_biz_rel',
                                text: '加入备选供方'
                            })
                        }
                        if (self.checkActionPerm('add_real_adopted_com')) {
                            actionList.push({
                                name: 'add_real_adopted_com',
                                text: '入选供方公司'
                            })
                        }
                        if (self.checkActionPerm('source_mgmt')) {
                            actionList.push({
                                name: 'source_mgmt',
                                text: '来源管理'
                            })
                        }
                        if (self.checkActionPerm('view_log')) {
                            actionList.push({
                                name: 'view_log',
                                text: '查看日志'
                            })
                        }
                        if (self.checkActionPerm('terminated') && row.curValid == true && !row.fullfilled && !row.checked && row.lockMode == 0 && !row.offline && !row.terminated && row.fstPartyId == self.userInfo.scopeEntity.id) {
                            actionList.push({
                                name: 'terminated',
                                text: '异常终止'
                            })
                        }
//                    if(self.contractType != self.goodsPurch.value && row.confirmed && row.curValid && !row.fullfilled && !row.closed && row.lockMode != 1 && !row.terminated) {
//                        actionList.push({
//                            name: 'applied_com',
//                            text: '适用机构'
//                        })
//                    }
                        actionList.push({
                            name: 'mail',
                            text: '站内信'
                        });
                        if (self.contractType != self.servcPurch.value && (row.curValid == true || row.closed) && !row.offline && !row.terminatedc) {
                            actionList.push({
                                name: 'view_purch_receipt',
                                text: '验收单'
                            });
                        }
                        if (self.contractType != self.servcPurch.value && new Date(row.dateEnd).getTime() < new Date().getTime()) {
                            actionList.push({
                                name: 'update_adoptedDevice_disabled',
                                text: '禁用入选商品'
                            });
                        }
                        if (self.contractType != self.servcPurch.value && row.confirmed && row.curValid && !row.fullfilled && !row.closed && row.lockMode == 0 && !row.terminated) {
                            actionList.push({
                                name: 'update_adoptedDevice_enable',
                                text: '启用入选商品'
                            });
                        }
                        return actionList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'no': function (row, colName, colValue, rowIndex, btnName) {
                        if (self.checkActionPerm('view')) {
                            self.goRegisterContract(row.id, 'chakan');
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if (btnName == 'modify') {
                            self.goRegisterContract(row.id, 'edit');
                        } else if (btnName == 'pre_pay') {
                            self.doPayPre(row)
                        } else if (btnName == 'apply') {
                            self.applyAuditDlg(row)
                        } else if (btnName == 'audit') {
                            self.confirmContract(row)
                        } else if (btnName == 'invalidate') {
                            self.cancelledGoodsContract(row)
                        } else if (btnName == 'change') {
                            self.goRegisterContract(row.id, 'change')
                        } else if (btnName == 'phase_change') {
                            // 付款阶段变更
                            self.toPhaseChange(row);
                        } else if (btnName == 'modification') {
                            // 合同修订
                            self.toModifyContract(row);
                        } else if (btnName == 'order_goods') {
                            self.toSaveGoodsOrder(row)
                        } else if (btnName == 'order_servc') {
                            self.toSaveServcOrder(row.id)
                        } else if (btnName == 'view_goods_order') {
                            self.toGoodsOrderList(row.id)
                        } else if (btnName == 'view_servc_order') {
                            self.toServcOrderList(row.id)
                        } else if (btnName == 'check') {
                            self.toCheckContract(row)
                        } else if (btnName == 'check_fulfill') {
                            self.tofulfillAudit(row)
                        } else if (btnName == 'keep_fulfilled') {
                            // 继续履约操作
                            self.doKeepFulfilled(row);
                        } else if (btnName == 'check_audit') {
                            self.toCheckContract(row, 1)
                        } else if (btnName == 'search_tag') {
                            self.searchTag(row.fstPartyFlag)
                        } else if (btnName == 'set_tag') {
                            self.setFstPartyFlag(row)
                        } else if (btnName == 'add_biz_rel') {
                            self.addQualifiedMerchant(row.sndPartyId, row.sndPartyType)
                        } else if (btnName == 'add_real_adopted_com') {
                            self.addRealAdoptedComRel(row.id);
                        } else if (btnName == 'source_mgmt') {
                            let flag = 'goods';
                            if (self.contractType == self.goodsPurch.value) {
                                flag = 'goods';
                            } else if (self.contractType == self.servcPurch.value) {
                                flag = 'servc';
                            } else if (self.contractType == self.integPurch.value) {
                                flag = 'goodsAndServc';
                            }
                            self.showSourceTraceDlg(row, flag)
                        } else if (btnName == 'view_log') {
                            self.showLogDlg(row.no)
                        } else if (btnName == 'terminated') {
                            self.doAbort(row)
                        } else if (btnName == 'applied_com') {
                            self.showAppliedShopDlg(row)
                        } else if (btnName == 'mail') {
                            self.openSendMsgDlg(row)
                        } else if (btnName == 'view_purch_receipt') {
                            self.toViewPurchReceipt(row);
                        } else if (btnName == 'update_adoptedDevice_enable') {
                            self.updateAdoptedDeviceDisabled(row.id, false);
                        } else if (btnName == 'update_adoptedDevice_disabled') {
                            self.updateAdoptedDeviceDisabled(row.id, true);
                        }
                    }
                });
            },
            searchSyncRefresh: function (queryModel) {
                this.queryModel = queryModel;
                //
                this.pageNumber = 1;
                this.getContractList(this.checkStateValue);
            },
            checkActionPerm: function (action) {
                return checkUserActionPerm(this.thisPath, action, null);
            },
            getStaffByComId: function () {
                let self = this;
                let postData = {};
                retailerApi.getRetailerStaffListByComId(postData, function (result) {
                    if (result.type === "info") {
                        self.retailerStaffList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            changeCheckBox: function () {
                this.getContractList(this.checkStateValue);
            },
            searchTag: function (tag) {
                this.fstPartyFlag = tag;
                this.queryModel.filterItems.fstPartyFlag = tag;
                this.getContractList(this.checkStateValue);
            },
            getCurrentUserInfo: function () {
                let self = this;
                let postData = {};
                userApi.getUserInfoByContext(postData, function (result) {
                    if (result.type == "info") {
                        self.userInfo = result.data;
                        if (Utils.isNoB(self.currentRealComId)) {
                            self.selectRealComId = result.data.scopeEntity.realComId;
                        } else {
                            self.selectRealComId = self.currentRealComId;
                        }
                    }
                });
            },
            checkComCatChange: function (eventData) {
                this.selectRealComId = eventData.id;
                //
                this.getContractList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getContractList(this.checkStateValue);
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getContractList(this.checkStateValue);
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getContractState: function () {
                this.contractStateList = getEnumMap('contractState', 'value2text');

                this.goodsPurch = getEnumInfoWith("contractType", 'name', 'GoodsPurch');
                this.servcPurch = getEnumInfoWith("contractType", 'name', 'ServcPurch');
                this.integPurch = getEnumInfoWith("contractType", 'name', 'IntegPurch');

                this.callBidDocSource = getEnumInfoWith("bizSrcFlag", 'name', 'BidDoc');
                this.priceInqrySource = getEnumInfoWith("bizSrcFlag", 'name', 'PriceInqry');

                this.getCurrentUserInfo();
            },
            changeStatue: function (value) {
                let self = this;
                self.checkStateValue = value;
                self.pageNumber = 1;
                self.getContractList(value);
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getContractList: function (state) {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.realComId = self.selectRealComId || null;
                if (self.relevanceCallBid) {
                    filterItems.srcFlag = self.callBidDocSource.value;
                }
                if (self.relevanceReply) {
                    filterItems.srcFlag = self.priceInqrySource.value;
                }
                if (self.userCreate) {
                    filterItems.creatorId = self.userInfo.userId;
                }
                //
                filterItems.typeId = self.contractType;
                // TODO 可删除
                if (self.contractType == self.goodsPurch.value) {
                    filterItems.sndPartyType = self.goodsPurch.sndPartyType;
                } else if (self.contractType == self.servcPurch.value) {
                    filterItems.sndPartyType = self.servcPurch.sndPartyType;
                } else if (self.contractType == self.integPurch.value) {
                    filterItems.sndPartyType = self.integPurch.sndPartyType;
                }
                if (state == 1) {
                    filterItems.curValid = false;
                    filterItems.closed = false;
                } else if (state == 2) {
                    filterItems.curValid = true;
                    filterItems.confirmed = true;
                    filterItems.fullfilled = false;
                    filterItems.terminated = false;
                    filterItems.closed = false;
                } else if (state == 3) {
                    filterItems.curValid = true;
                    filterItems.fullfilled = true;
                    filterItems.checked = false;
                    filterItems.closed = false;
                } else if (state == 4) {
                    filterItems.curValid = true;
                    filterItems.checked = true;
                    filterItems.closed = false;
                } else if (state == -1) {
                    filterItems.curValid = false;
                    filterItems.closed = true;
                }
                if (!Utils.isNoB(self.sndPartyId)) {
                    filterItems.sndPartyId = self.sndPartyId;
                }
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                self.exportParams = Utils.merge({}, filterItems);
                let theLoad = MsgBox.loading("数据查询中.....");
                contractApi.getContractList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let data = result.data;
                        let contractList = data.rows || [];
                        self.contractList = Utils.merge([], contractList);
                        //结果应用
                        let pagination = data.pagination;
                        if (pagination != null) {
                            self.totalCount = pagination.totalCount;
                            self.pageNumber = pagination.pageNumber;
                            self.pageSize = pagination.pageSize;
                        }
                        self.renderTable(contractList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            goRegisterContract: function (contractId, operation) {
                let self = this;
                let postData = {};
                postData.merchantId = self.userInfo.scopeEntity.id;
                postData.merchantType = self.userInfo.scopeEntity.type;
                merchtQualiApi.existMerchantQualiTrade(postData, function (result) {
                    if (result.type == 'info') {
                        let existTrade = result.data;
                        if (existTrade) {
                            let query = {
                                selectRealComId: self.selectRealComId,
                                parentPath: self.thisPath
                            };
                            if (contractId != null) {
                                query.contractId = contractId;
                                query.operate = operation;
                            }
                            let title = '';
                            if (operation == 'chakan') {
                                title = '查看合同';
                            } else if (operation == 'edit') {
                                title = '编辑合同';
                            } else if (operation == 'change') {
                                title = '变更合同';
                            } else {
                                title = '新增合同';
                            }
                            if (operation == 'chakan') {
                                let swbTemplate = SwbRegisterGoodsPurchContract;
                                if (self.contractType == self.goodsPurch.value) {
                                    swbTemplate = SwbRegisterGoodsPurchContract;
                                } else if (self.contractType == self.servcPurch.value) {
                                    swbTemplate = SwbRegisterServcPurchContract;
                                } else if (self.contractType == self.integPurch.value) {
                                    swbTemplate = SwbRegisterIntegPurchContract;
                                }
                                showRouteLayer({
                                    title: title,
                                    query: query,
                                    template: swbTemplate
                                });
                            } else {
                                self.$router.push({
                                    path: self.path,
                                    query: query
                                });
                            }
                        } else {
                            MsgBox.warning("平台交易资质未认证，相关业务不能执行！");
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 付款阶段变更
            toPhaseChange: function (row) {
                let self = this;
                let params = {
                    id: row.id
                };
                openContractPhasedPaySettingModifyDlg(params, function (contract, confirmMsg, theDlg) {
                    if (!Utils.isNoB(confirmMsg)) {
                        self.$confirm(confirmMsg, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(function () {
                            //
                            self.doSavePhasedPaySetting(contract, theDlg);
                        }).catch(function () {
                        });
                    } else {
                        self.doSavePhasedPaySetting(contract, theDlg);
                    }
                });
            },
            doSavePhasedPaySetting(contract, theDlg) {
                let self = this;
                // 检查未结算的
                let postData = {};
                postData.pagination = {
                    pageSize: 10,
                    pageNumber: 1
                };
                postData.filterItems = {
                    contractId: contract.id,
                    deriveFalg: false,
                    directFlag: 1,
                    manualFlag: false,
                    settleProofId: -1,
                    tempFlag: false
                };
                receiptApi.getPurchReceiptList(postData, function (result) {
                    if(result.type == 'info') {
                        let totalCount = result.data.pagination.totalCount;
                        if (totalCount > 0) {
                            self.$confirm("您目前存在未完成结算的业务，此次变更将影响未结算部分，请确认是否继续变更操作", '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                contractApi.doSaveContractAcntPeriodFormAndPhasedPaySettingList(contract, function (result) {
                                    theDlg.close();
                                    MsgBox.success("操作成功！");
                                    self.getContractList(self.checkStateValue);
                                });
                            }).catch(function () {
                            });
                        } else {
                            contractApi.doSaveContractAcntPeriodFormAndPhasedPaySettingList(contract, function (result) {
                                theDlg.close();
                                MsgBox.success("操作成功！");
                                self.getContractList(self.checkStateValue);
                            });
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 合同修订
            toModifyContract: function (row) {
                if (this.contractType == this.goodsPurch.value) {
                    this.toModifyGoodsPurchContract(row);
                } else if (this.contractType == this.servcPurch.value) {
                    this.toModifyServcPurchContract(row);
                }
            },
            //
            toModifyGoodsPurchContract: function (row) {
                let self = this;
                let params = {
                    id: row.id
                };
                openContractModifyDlg(params, function (contract, theDlg) {
                    self.$confirm('确定要进行合同修订吗', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        let theLoad = MsgBox.loading("数据修改中.....");
                        contractApi.updateContractGoodsInfo(contract, function (result) {
                            theLoad.hide();
                            if (result.type == "info") {
                                theDlg.close();
                                MsgBox.success(result.message);
                                self.getContractList(self.checkStateValue);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }).catch(function () {
                    });
                });
            },
            //
            toModifyServcPurchContract: function (row) {
                let self = this;
                let params = {
                    id: row.id
                };
                openContractServcPurchModifyDlg(params, function (contract, theDlg) {
                    self.$confirm('确定要进行合同修订吗', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        let theLoad = MsgBox.loading("数据修改中.....");
                        contractApi.updateContractServcPurch(contract, function (result) {
                            theLoad.hide();
                            if (result.type == "info") {
                                theDlg.close();
                                MsgBox.success(result.message);
                                self.getContractList(self.checkStateValue);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }).catch(function () {
                    });
                });
            },
            //
            deleteContractById: function (id) {
                let self = this;
                self.$confirm('确定要删除该信息吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let item = {};
                    item.id = id;
                    contractApi.deleteContract(item, function (result) {
                        if (result.type === "info") {
                            self.getContractList(self.checkStateValue);
                            MsgBox.success('删除成功!');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            applyAuditDlg: function (item) {
                let self = this;
//                if (item.fstPartyHtBh == null) {
//                    MsgBox.warning('请编辑合同，填写合同编号');
//                    return;
//                }
                let dlgArgs = {};
                dlgArgs.rescUrl = this.thisPath;
                dlgArgs.action = 'audit';
                dlgArgs.useDesc = true;
                dlgArgs.initPostId = item.fstPartyAuditorPostId;
                dlgArgs.applyDesc = item.fstPartyApplyDesc;
                showComActionPostSelectDlg(dlgArgs, function (resultData) {
                    let postId = resultData.postId;
                    let applyDesc = resultData.applyDesc;
                    if (postId == null) {
                        MsgBox.warning("请选择审核岗位");
                        return false;
                    }
                    item.fstPartyAuditorPostId = postId;
                    item.fstPartyApplyDesc = applyDesc;
                    let theLoad = MsgBox.loading("申请审核中.....");
                    contractApi.applyContract(item, function (result) {
                        theLoad.hide();
                        if (result.type === "info") {
                            MsgBox.success('申请成功!');
                            self.getContractList(self.checkStateValue);
                        } else {
                            MsgBox.warning(result.message);
                            self.getContractList(self.checkStateValue);
                        }
                    });
                }, this);
            },
            confirmContract: function (item) {
                let self = this;
                self.$confirm('请先查看合同内容！是否审核确认此合同。', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theDlg = Vue.$showDialog({
                        title: '审核确认',
                        showCloseBtn: true,
                        width: 530,
                        height: 620,
                        template: '<div class="simple-form">' +
                            '<div class="form-group center">' +
                            '<div class="form-label">' +
                            '<label>&nbsp;</label>' +
                            '</div>' +
                            '<div class="form-value width-1-5x">' +
                            '<el-radio class="radio" v-model="auditState" :label=1>通过</el-radio>' +
                            '<el-radio class="radio" v-model="auditState" :label=-1>拒绝</el-radio>' +
                            '</div>' +
                            '</div>' +
                            '<div class="form-group center">' +
                            '<div class="form-label">' +
                            '<label>审核描述</label>' +
                            '</div>' +
                            '<div class="form-value width-1-5x">' +
                            '<el-input type="textarea" v-model="auditDesc"></el-input>' +
                            '</div>' +
                            '</div>' +
                            '<div v-if = "auditState == 1">' +
                            '<div class="form-group center">' +
                            '<div class="form-label">' +
                            '<label>是否给对方发站内信</label>' +
                            '</div>' +
                            '<div class="form-value width-1-5x">' +
                            '<el-radio  class="radio" v-model="msgIsSend" :label=true>是</el-radio>' +
                            '<el-radio  class="radio" v-model="msgIsSend" :label=false>否</el-radio>' +
                            '</div>' +
                            '</div>' +
                            '<div v-if="msgIsSend" class="form-group center">' +
                            '<div class="form-label">' +
                            '<label>主题</label>' +
                            '</div>' +
                            '<div class="form-value width-1-5x">' +
                            '<el-input v-model="msgSubject"></el-input>' +
                            '</div>' +
                            '</div>' +
                            '<div v-if="msgIsSend" class="form-group center">' +
                            '<div class="form-label">' +
                            '<label>内容</label>' +
                            '</div>' +
                            '<div class="form-value width-1-5x">' +
                            '<el-input type="textarea" :autosize="{ minRows: 7, maxRows: 11 }" v-model="msgContent"></el-input>' +
                            '</div>' +
                            '</div>' +
                            '</div>' +
                            '</div>',
                        data: {
                            auditState: -1,
                            auditDesc: null,
                            msgIsSend: false,
                            msgSubject: null,
                            msgContent: null
                        },
                        methods: {},
                        okClicked: function () {
                            let selfDlg = this;
                            if (selfDlg.auditState == 1 && selfDlg.msgIsSend) {
                                if (selfDlg.msgSubject == null) {
                                    MsgBox.warning("请填写主题");
                                    return false;
                                }
                                if (selfDlg.msgContent == null) {
                                    MsgBox.warning("请填写内容");
                                    return false;
                                }
                                item.msgSubject = selfDlg.msgSubject;
                                item.msgContent = selfDlg.msgContent;
                                let hashUrl = "";
                                let data = {no: item.no};
                                if (self.contractType == self.goodsPurch.value) {
                                    hashUrl = Utils.makeUrl(SwbGoodsPurchContractList.path, data);
                                } else if (self.contractType == self.servcPurch.value) {
                                    hashUrl = Utils.makeUrl(SwbServcPurchContractList.path, data);
                                } else if (self.contractType == self.integPurch.value) {
                                    hashUrl = Utils.makeUrl(SwbIntegPurchContractList.path, data);
                                }
                                item.msgUrl = hashUrl;
                            } else {
                                selfDlg.msgIsSend = false;
                            }
                            item.msgIsSend = selfDlg.msgIsSend;
                            item.fstPartyAuditState = selfDlg.auditState;
                            item.fstPartyAuditDesc = selfDlg.auditDesc;
                            let theLoad = MsgBox.loading("审核中.....");
                            contractApi.auditAndConfirmContract(item, function (result) {
                                theLoad.hide();
                                if (result.type === "info") {
                                    theDlg.close();
                                    if (self.contractType == self.goodsPurch.value && !Utils.isNoB(result.message)) {
                                        // 为使结算可正常完成，请维护入选供方关系里的公司关系!
                                        MsgBox.success(result.message);
                                    } else {
                                        MsgBox.success('审核成功!');
                                    }
                                    self.getContractList(self.checkStateValue);
                                } else {
                                    MsgBox.warning(result.message);
                                    self.getContractList(self.checkStateValue);
                                    return false;
                                    // MsgBox.warning(result.message);
                                }
                            });
                            return false;
                        },
                        lifecycle: {
                            created: function () {
                                let selfDlg = this;
                            }
                        }
                    });
                }).catch(function () {
                });
            },
            toSaveGoodsOrder: function (row) {
                let bizAreaIds = Utils.isTrue(row.bizAreaFlag) ? row.bizAreaIds : [];
                let bizAreaIdStr = bizAreaIds.join(",") || null;
                let bizFormIds = row.bizFormIds || [];
                let bizFormIdStr = bizFormIds.join(",") || null;
                this.$getRouter().push({
                    path: SwbSaveGoodsOrder.path,
                    query: {
                        contractId: row.id,
                        contractType: row.typeId, // 用于控制是否可查看价格
                        bizAreaIdStr: bizAreaIdStr,
                        bizFormIdStr: bizFormIdStr
                    }
                });
            },
            toSaveServcOrder: function (id) {
                this.$getRouter().push({
                    path: SwbServcOrderCreate.path,
                    query: {
                        contractId: id,
                    }
                });
            },
            toGoodsOrderList: function (id) {
                showRouteLayer({
                    title: '商品订单',
                    query: {
                        contractId: id,
                    },
                    template: SwbContractGoodsOrderList
                });
            },
            toServcOrderList: function (id) {
                this.$getRouter().push({
                    path: SwbContractServcOrderList.path,
                    query: {
                        contractId: id,
                    }
                });
            },
            toCheckContract: function (row, type) {
                let self = this;
                let title = type != null ? '审核验收完成申请' : '验收合同';
                Vue.$showDialog({
                    title: title,
                    showCloseBtn: true,
                    height: 530,
                    template: '<div>' +
                        '<el-radio v-if="type != null" class="radio" v-model="checkAuditState" :label=1>通过</el-radio>' +
                        '<el-radio v-if="type != null" class="radio" v-model="checkAuditState" :label=-1>拒绝</el-radio>' +
                        '<swb-check-contract :contractId = "contractId"  ref="swb_check_contract_info"></swb-check-contract>' +
                        '<span class="fl">验收描述</span>' +
                        '<div class="form-value width-1-5x fl ml20">' +
                        '<el-input type="textarea" v-model="checkAuditDesc"></el-input>' +
                        '</div>' +
                        '</div>',
                    data: {
                        contractId: row.id,
                        type: type,
                        checkAuditState: -1,
                        checkAuditDesc: null
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_check_contract_info.getDlgResult();
                        if (!result) {
                            return false;
                        }
                        if (result.type === 'info') {
                            let contract = {};
                            contract.id = row.id;
                            if (type != null) {
                                contract.checkAuditState = selfDlg.checkAuditState;
                            } else {
                                contract.checkAuditState = 1;
                            }
                            contract.checkAuditDesc = selfDlg.checkAuditDesc;
                            contract.contractCheckFileList = result.data;
                            let theLoad = MsgBox.loading();
                            contractApi.getContractCheckResult(contract, function (result) {
                                theLoad.hide();
                                if (result.type === "info") {
                                    self.getContractList(self.checkStateValue);
                                    if (type != null) {
                                        MsgBox.success('审核成功!');
                                    } else {
                                        MsgBox.success('验收成功!');
                                    }
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        } else {
                            MsgBox.warning(result.message);
                            return false;
                        }
                        return true;
                    },
                    lifecycle: {}
                });
            },
            cancelledGoodsContract: function (row) {
                let self = this;
                self.$confirm('确定要作废吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.contractId = row.id;
                    let theLoad = MsgBox.loading("作废中.....");
                    contractApi.doInvalidContract(postData, function (result) {
                        theLoad.hide();
                        if (result.type == "info") {
                            MsgBox.success("作废成功");
                            self.getContractList(self.checkStateValue);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            tofulfillAudit: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '审核履约完成审核',
                    showCloseBtn: true,
                    width: 530,
                    height: 300,
                    template: '<div class="simple-form">' +
                        '<div class="form-group center">' +
                        '<div class="form-label">' +
                        '<label>&nbsp;</label>' +
                        '</div>' +
                        '<div class="form-value width-1-5x">' +
                        '<el-radio class="radio" v-model="fulfillAuditState" :label=1>通过</el-radio>' +
                        '<el-radio class="radio" v-model="fulfillAuditState" :label=-1>拒绝</el-radio>' +
                        '</div>' +
                        '</div>' +
                        '<div class="form-group center">' +
                        '<div class="form-label">' +
                        '<label>审核描述</label>' +
                        '</div>' +
                        '<div class="form-value width-1-5x">' +
                        '<el-input type="textarea" v-model="fulfillAuditDesc"></el-input>' +
                        '</div>' +
                        '</div>' +
                        '</div>',
                    data: {
                        fulfillAuditState: -1,
                        fulfillAuditDesc: null,
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        row.fulfillAuditState = selfDlg.fulfillAuditState;
                        row.fulfillAuditDesc = selfDlg.fulfillAuditDesc;
                        let theLoad = MsgBox.loading("审核中.....");
                        contractApi.auditContractFulfillFinished(row, function (result) {
                            theLoad.hide();
                            if (result.type === "info") {
                                self.getContractList(self.checkStateValue);
                                MsgBox.success('审核成功!');
                            } else {
                                MsgBox.warning(result.message);
                            }
                        })
                    },
                    lifecycle: {}
                });
            },
            // 继续履约
            doKeepFulfilled: function (row) {
                let self = this;
                let title = '继续履约';
                if (self.contractType == self.servcPurch.value) {
                    title += "- 相关保养、检验计划除提前结束的，其他会自动激活！"
                }
                console.log(title.toHtml)
                let theDlg = Vue.$showDialog({
                    title: title,
                    showCloseBtn: true,
                    width: 500,
                    height: 300,
                    template: '<swb-prop-editor ref="prop_editor" :title="editorTitle" :noGrid="true" :showBtnBar="false" :width="430" :widthForLabel="120" :propList="propList" :viewMode="false" :readOnly="false"></swb-prop-editor>',
                    data: {
                        editorTitle: "",
                        propList: [{
                            label: '结束时间', code: 'dateEnd', value: row.dateEnd, valueType: 'Date', tooltip: '', required: true, width: 300
                        }]
                    },
                    okClicked: function () {
                        let propEditor = this.$refs['prop_editor'];
                        if (propEditor.validate()) {
                            let postData = propEditor.getPropValues();
                            let currentDate = new Date().format("yyyy-MM-dd");
                            if (postData.dateEnd <= currentDate) {
                                MsgBox.warning("结束时间必须在当前时间之后");
                                return false;
                            }
                            postData.id = row.id;
                            let theLoading = MsgBox.loading();
                            contractApi.doUpdateContractKeepFulfilled(postData, function (result) {
                                theLoading.hide();
                                if (result.type == "info") {
                                    theDlg.close();
                                    MsgBox.success('操作成功');
                                    self.getContractList(self.checkStateValue);
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }
                        return false;
                    }
                });
            },
            setFstPartyFlag: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '设置标签',
                    showCloseBtn: true,
                    width: 530,
                    height: 300,
                    template: '<div class="simple-form">' +
                        '<div class="form-group center">' +
                        '<div class="form-label">' +
                        '<label>&nbsp;</label>' +
                        '</div>' +
                        '</div>' +
                        '<div class="form-group center">' +
                        '<div class="form-label">' +
                        '<label>标签</label>' +
                        '</div>' +
                        '<div class="form-value width-1-5x">' +
                        '<el-input type="text" v-model="fstPartyFlag"></el-input>' +
                        '</div>' +
                        '</div>' +
                        '</div>',
                    data: {
                        fstPartyFlag: row.fstPartyFlag
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        row.fstPartyFlag = selfDlg.fstPartyFlag;
                        let theLoad = MsgBox.loading("保存中...");
                        contractApi.updateContract(row, function (result) {
                            if (result.type === "info") {
                                self.getContractList(self.checkStateValue);
                                MsgBox.success('设置成功!');
                            } else {
                                MsgBox.warning(result.message);
                            }
                            theLoad.hide();
                        })
                    },
                    lifecycle: {}
                });
            },
            // 加入合格商户
            addQualifiedMerchant: function (merchantId, merchantType) {
                // 为了使用原有的接口，设置数据
                let peerMerchantIds = [];
                peerMerchantIds.add(merchantId);
                //
                let postData = {};
                postData.bizRelIds = peerMerchantIds;
                postData.peerMerchantType = merchantType;
                merchtComnApi.saveMerchantBizRel(postData, function (result) {
                    if (result != null) {
                        if (result.type == 'info') {
                            MsgBox.success(result.message);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    }
                });
            },
            addRealAdoptedComRel: function (contractId) {
                let self = this;
                self.$confirm('确定要加入入选供方公司吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    merchtComnApi.saveRealAdoptedComForContract(contractId, function (result) {
                        theLoad.hide();
                        if (result.type === "info") {
                            Toast.show("操作成功");
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            showSourceTraceDlg: function (row, type) {
                let okVisible = true;
                if (row.srcFixed) {
                    okVisible = false;
                }
                let self = this;
                Vue.$showDialog({
                    title: '跟踪信息',
                    width: '75%',
                    height: 700,
                    showCloseBtn: true,
                    okVisible: okVisible,
                    template: '<div>' +
                        '<swb-show-source-trace :contractId = "id" :type="type" :toDealInqryVoucherList="toDealInqryVoucherList" :toPriceInqryVoucherList="toPriceInqryVoucherList" :toCallBidDocList="toCallBidDocList" ref="swb_show_source_trace"></swb-show-source-trace>' +
                        '</div>',
                    data: {
                        id: row.id,
                        type: type
                    },
                    methods: {
                        toDealInqryVoucherList: function (no) {
                            self.toDealInqryVoucherList(no);
                        },
                        toPriceInqryVoucherList: function (no) {
                            self.toPriceInqryVoucherList(no);
                        },
                        toCallBidDocList: function (no) {
                            self.toCallBidDocList(no);
                        }
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_show_source_trace.getDlgResult() || {};
                        if (result.type == "info") {
                            let item = result.data;
                            if (row.srcId == item.srcId && row.srcFlag == item.srcFlag && row.srcWinId == item.srcWinId) {
                                return true;
                            }
                            row.srcId = item.srcId;
                            row.srcWinId = item.srcWinId || null;
                            row.srcFlag = item.srcFlag;
                            let lastMsgBoxDlg = MsgBox.loading();
                            contractApi.updateContract(row, function (result) {
                                if (result.type === "info") {
                                    self.getContractList(self.checkStateValue);
                                    MsgBox.success('设置成功!');
                                } else {
                                    MsgBox.warning(result.message);
                                }
                                lastMsgBoxDlg.hide();
                            })
                        }
                    },
                    lifecycle: {
                        created: function () {
                        }
                    }
                });
            },
            toDealInqryVoucherList: function (no) {
                let data = {no: no};
                let hashUrl = Utils.makeUrl(SwbDealInqryVoucherList.path, data);
                appConf.openPageRouteUrl(null, "/bench/home", hashUrl);
            },
            toPriceInqryVoucherList: function (no) {
                let data = {no: no};
                let hashUrl = Utils.makeUrl(SwbPriceInpryList.path, data);
                appConf.openPageRouteUrl(null, "/bench/home", hashUrl);
            },
            toCallBidDocList: function (no) {
                let data = {no: no};
                let hashUrl = Utils.makeUrl(SwbCallBidDocList.path, data);
                appConf.openPageRouteUrl(null, "/bench/home", hashUrl);
            },
            openSendMsgDlg: function (contract) {
                // openSendMsgListDlg(null, "voucher", "contract", contract.no, 'fstParty', contract.id);
                let receiverData = {};
                //
                receiverData.currentPostIds = [
                    contract.fstPartyConfirmerPostId
                ];
                receiverData.currentMerchtType = contract.fstPartyType; // getEnumInfoWith('merchantType', 'name', 'Retailer').value;
                receiverData.otherPostIds = [
                    contract.sndPartyConfirmerPostId
                ];
                receiverData.otherMerchtType = contract.sndPartyType;
                receiverData.voucherChildType = this.contractType;
                //
                showMsgDlg(true, 'voucher', voucherType.CONTRACT, contract.no, receiverData);
            },
            // 查看合同日志
            showLogDlg: function (contractNo) {
                //
                openContractLogListDlg(contractNo);
            },
            // 异常中止操作
            doAbort: function (row) {
                let self = this;
                //
                self.$confirm('确定要执行该操作吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = row.id;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    contractApi.doAbortContract(postData, function (result) {
                        if (result.type === "info") {
                            self.getContractList(self.checkStateValue);
                            MsgBox.success('操作成功!');
                        } else {
                            MsgBox.warning(result.message);
                        }
                        msgBoxDlg.hide();
                    });
                }).catch(function () {
                });
            },
            // 适用机构
            showAppliedShopDlg(row) {
                let self = this;
                Vue.$showDialog({
                    title: "合同适用机构",
                    width: 1300,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    template: '<div>' +
                        '<swb-contract-applied-shop-list :contractId="contractId" :contractType="contractType" :kindId="kindId" :contractOriginalNo="contractOriginalNo" :realComId="realComId" :signGroupId="signGroupId" :bizAreaIds="bizAreaIds" ref="swb_contract_applied_shop_list"></swb-contract-applied-shop-list>' +
                        '</div>',
                    data: {
                        contractId: row.id,
                        kindId: row.kindId,
                        contractType: self.contractType,
                        contractOriginalNo: row.originalNo,
                        realComId: row.fstPartyRealComId,
                        signGroupId: row.signGroupId,
                        bizAreaIds: Utils.isTrue(row.bizAreaFlag) ? row.bizAreaIds : [],
                        bizFormIds: row.bizFormIds || []
                    },
                    methods: {}
                });
            },
            // 预付功能
            doPayPre(row) {
                let self = this;
                let params = {
                    title: '合同金额 - 预付',
                    doPrePay: true,
                    showBtn: true,
                    payPreFilter: {
                        contractId: row.id,
                        contractNo: row.no,
                        sellerRealComId: row.sndPartyRealComId,
                        buyerRealComId: row.fstPartyRealComId,
                        payPhaseTplId: row.payPhaseTplId,
                        amount: row.estmtAmount
                    },
                    filter: {
                        contractNo: row.no,
                        lockMode: row.lockMode
                    },
                    parentSelf: self,
                    parentPath: self.thisPath
                };
                showPayVoucherListForSelectDlg(params, function (refresh) {
                    //
                    if (Utils.isTrue(refresh)) {
                        self.getContractList(self.checkStateValue);
                    }
                });
            },
            // 导入内容校验
            openContractImpCheckDlg(fileObj, updateFlag) {
                let self = this;
                // 先调用一次检验方法
                let contractImpDto = {
                    updateFlag: updateFlag,
                    originalFileName: fileObj.extra.originalFileName,
                    impInfoList: fileObj.extra.impInfoList || []
                };
                // 大于500条目不能执行统一检查
                if (contractImpDto.impInfoList.length > 500) {
                    let fileObj = {
                        extra: {
                            updateFlag: updateFlag,
                            originalFileName: contractImpDto.originalFileName,
                            contractImpInfoList: contractImpDto.impInfoList
                        }
                    };
                    openContractImpCheckDlg(fileObj, self.scopeId, function (contractImpResult) {
                        // 导入后回调的方法,刷新列表
                        self.getContractList(self.checkStateValue);
                        //
                        let importStatis = contractImpResult.importStatis;
                        if (importStatis != null) {
                            MsgBox.info("导入商品总数量：{0}个".format(importStatis.goodsCount));
                        } else {
                            MsgBox.info("执行完毕");
                        }
                    });
                } else {
                    //
                    let theLoading = MsgBox.loading("正在检查导入数据");
                    contractApi.validateContractImpModel(contractImpDto, function (result) {
                        theLoading.close();
                        let impDto = result.data;
                        let fileObj = {
                            extra: {
                                updateFlag: updateFlag,
                                originalFileName: impDto.originalFileName,
                                contractImpInfoList: impDto.impInfoList
                            }
                        };
                        openContractImpCheckDlg(fileObj, self.scopeId, function (contractImpResult) {
                            // 导入后回调的方法,刷新列表
                            self.getContractList(self.checkStateValue);
                            //
                            let importStatis = contractImpResult.importStatis;
                            if (importStatis != null) {
                                MsgBox.info("导入商品总数量：{0}个".format(importStatis.goodsCount));
                            } else {
                                MsgBox.info("执行完毕");
                            }
                        });
                    });
                }
            },
            // 导入说明
            showFormatElpx: function () {
                openContractFormatExplDlg(this.scopeId);
            },
            generalImport: function () {
                let self = this;
                let usage = "contract.by.goods.import";
                if (Utils.isTrue(self.showAssetInfo)) {
                    usage = "contract.by.def.import";
                }
                let uploadParams = {
                    title: "合同导入",
                    fileGroup: "contract.import",
                    lableText: "新增导入",
                    usage: usage,
                    fileGroup2: "contract.import",
                    lableText2: "更新导入",
                    downloadText2: "导出数据",
                    usage2: usage,
                    multipleFile: false,
                    showFormatElpx: function () {
                        openContractFormatExplDlg(self.scopeId);
                    }
                };
                fileUploadGroupShowDlg(uploadParams, "/api/contract/imp/model/template/file/download", function (result, theDlg) {
                    // theDlg 关闭弹框
                    theDlg.close();
                    if (result.type === 'info') {
                        let files = result.data.files;
                        self.file = files[0];
                        // 文件是否按模版导入
                        let errorMsgList = self.file.extra.errorMsgList;
                        if (!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                            MsgBox.warning(errorMsgList.join("<br/>"));
                            return;
                        }
                        let updateFlag = false;
                        if (Utils.isTrue(result.secondFlag)) {
                            updateFlag = true;
                        }
                        // 验证此文件中导入的内容
                        self.openContractImpCheckDlg(self.file, updateFlag);
                    } else {
                        MsgBox.warning(result.message);
                    }
                }, null, null, null, function () {
                    // 导出合同列表
                    self.exportContractList();
                });
            },
            exportContractList: function () {
                let self = this;
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportParams);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let multipleSelection = this.getTableSelection();
                if (multipleSelection.length > 0) {
                    let ids = [];
                    let sndPartyIds = [];
                    let fstPartyFlag = false;
                    let canImport = true;
                    let contractNo = '';
                    multipleSelection.forEach(function (el) {
                        ids.push(el.id);
                        if (!sndPartyIds.contains(el.sndPartyId)) {
                            sndPartyIds.push(el.sndPartyId);
                        }
                        if (!(el.fstPartyConfirmed == false && el.fstPartyApplyState != 1 || el.confirmed && el.curValid && !el.checked && el.lockMode == 0 && !el.offline && !el.terminated)) {
                            canImport = false;
                            if (Utils.isNoB(contractNo)) {
                                contractNo = contractNo + el.no;
                            } else {
                                contractNo = contractNo + '、' + el.no;
                            }
                        }
                        if (el.fstPartyId != self.userInfo.scopeEntity.id) {
                            fstPartyFlag = true;
                        }
                    });
                    if (sndPartyIds.length > 1) {
                        MsgBox.warning("只能选择同一供应商的合同！");
                        return;
                    }
                    if (Utils.isTrue(fstPartyFlag)) {
                        MsgBox.warning("只能导出签约分管商户为当前商户的合同！");
                        return;
                    }
                    if (Utils.isFalse(canImport)) {
                        MsgBox.warning("合同[" + contractNo + "]不可编辑，不允许导出！");
                        return;
                    }
                    filterItems.vendorId = sndPartyIds[0];
                    filterItems.ids = ids;
                } else {
                    if (Utils.isNoB(filterItems.sndPartyName)) {
                        MsgBox.warning("请选择要导出的合同！");
                        return;
                    }
                }
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let contractImpDto = {
                    vendorId: filterItems.vendorId,
                    exportData: Utils.merge({}, postData)
                };
                //
                contractApi.contractImpModelForExport(contractImpDto, function (result) {
                    if (result.type == 'info') {
                        Toast.show("正在导出，请稍等！");
                        Utils.downloadFile(getAppUrl(result.data));
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 跳转验收单
            toViewPurchReceipt: function (contract) {
                showRouteLayer({
                    title: '验收单',
                    query: {
                        trunsFlag: true,
                        contractFlag: true,
                        contractNo: contract.no
                    },
                    template: SwbPurchReceiptList
                });
            },
            updateAdoptedDeviceDisabled: function (contractId, disabled) {
                this.$confirm('确定要' + (disabled ? "禁用" : "启用") + '吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        contractId: contractId,
                        disabled: disabled
                    };
                    let theLoad = MsgBox.loading();
                    devcReqrApi.updateAdoptedDeviceDisabledByContractId(postData, function (result) {
                        theLoad.hide();
                        if (result.type == 'info') {
                            MsgBox.success((disabled ? "禁用" : "启用") + "成功");
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ComnContractList.vue